export enum SearchTarget {
  all = 'all',
  contracts = 'contracts',
  insuranceCases = 'insuranceCases',
}


